import React from "react";
import Login from ".";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { GOOGLE_CAPTCHA_SITE_KEY_V3 } from "../../utils/constants/appConstants";

const LoginWithRecaptcha = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={GOOGLE_CAPTCHA_SITE_KEY_V3}
      scriptProps={{ async: true, defer: true, appendTo: "head" }}
      container={{
        parameters: {
          badge: "bottomright"
        }
      }}
    >
      <Login />
    </GoogleReCaptchaProvider>
  );
};

export default LoginWithRecaptcha;
